import React from 'react';

import ProtectedData from 'pages/item/v2/components/ProtectedData';
import isEmpty from 'utils/is-empty';

import Link from '..//Link';
import TablePanel from '../TablePanel';

export interface SoftwareProps {
    affectedSoftware:
        | {
              cpeName: string;
              name: string;
              operator: string;
              version: string;
          }[]
        | undefined;
}

const Software: React.FC<SoftwareProps> = ({ affectedSoftware }) => {
    if (isEmpty(affectedSoftware)) {
        return null;
    }

    return (
        <TablePanel
            data={affectedSoftware}
            config={[
                {
                    name: 'CPE',
                    sortField: 'cpeName',
                    field({ cpeName }) {
                        return <Link href={`/search?query=affectedSoftware.cpeName:"${cpeName}"`} label={cpeName} />;
                    }
                },
                {
                    name: 'Name',
                    sortField: 'name',
                    field({ name }) {
                        return <Link href={`/search?query=affectedSoftware.name:"${name}"`} label={name} />;
                    }
                },
                {
                    name: 'Operator',
                    sortField: 'operator',
                    field({ operator }) {
                        return <ProtectedData data={operator} />;
                    }
                },
                {
                    name: 'Version',
                    sortField: 'version',
                    field({ version, name }) {
                        return (
                            <Link
                                href={`/search?query=affectedSoftware.name:"${name}" AND affectedSoftware.version:${version}`}
                                label={version}
                            />
                        );
                    }
                }
            ]}
        />
    );
};

export default Software;
